<template>
  <div class="iframe">
    <!-- KKbox iframe -->
    <div class="KK_iframe_container">
      <div class="close_kkbox" v-if="kkboxIframeId">
        <span @click="kkboxClose">
          <i class="fas fa-times-circle"></i>
        </span>
      </div>
      <iframe
        class="kkboxIframe"
        v-if="kkboxIframeId"
        allow="autoplay"
        :src="`https://widget.kkbox.com/v1/?id=${kkboxIframeId}&type=${iframeType}&terr=TW&lang=TC&autoplay=true`"
        frameborder="0"
      ></iframe>
    </div>

    <!-- YT iframe -->
    <div class="TY_iframe_container">
      <div class="close_YT" v-if="youtubeIframeId">
        <span @click="YTClose">
          <i class="fas fa-times-circle"></i>
        </span>
      </div>
      <iframe
        id="player"
        type="text/html"
        v-if="youtubeIframeId"
        width="300"
        height="200"
        :src="`https://www.youtube.com/embed/${youtubeIframeId}?autoplay=1`"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iframeType: "song"
    };
  },
  computed: {
    kkboxIframeId() {
      return this.$store.state.iframeId;
    },
    youtubeIframeId() {
      return this.$store.state.YTTrackId;
    }
  },
  methods: {
    kkboxClose() {
      const vm = this;
      vm.$store.commit("IFRAMEID", "");
    },
    YTClose() {
      const vm = this;
      vm.$store.commit("YTTRACKID", "");
    }
  }
};
</script>

<style>
@import url("../assets/iframe.css");
</style>